import { Component, Vue } from 'vue-property-decorator';

import Sidebar from '@/components/Global/Sidebar/Sidebar.vue';

@Component({
     name: 'ClaimThankYou',
     components: {
          Sidebar,
     },
})
export default class ThankYouSubmissionMixin extends Vue {
     get claim() {
          const claim = this.$route.params.claim;

          if (claim === undefined) {
               this.$router.push({
                    name: 'submitclaim',
               });
          }
          return claim;
     }
}
